module.exports = __webpack_public_path__ + "img/spinner-1s-200px.8c34babb.gif";